__turbopack_context__.v({
  "arrow": "ScrollDownArrow-module-scss-module__EPlmyW__arrow",
  "container": "ScrollDownArrow-module-scss-module__EPlmyW__container",
});
